import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-horizontal-play",
  "use": "icon-horizontal-play-usage",
  "viewBox": "0 0 24 25",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 24 25\" id=\"icon-horizontal-play\"><path fill=\"#437DFF\" d=\"m10.133 15.248 4.341-3.197a.303.303 0 0 0 0-.475l-4.341-3.2a.303.303 0 0 0-.49.236v6.397c0 .252.292.394.49.239\" /><path fill=\"#437DFF\" d=\"M23.068 4.1H.93a.856.856 0 0 0-.857.857v14.249c0 .474.383.857.857.857h22.138a.856.856 0 0 0 .857-.857V4.957a.856.856 0 0 0-.857-.857m-1.071 14.034H2.002V6.03h19.995z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol